import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ResultsList from '../components/ResultsList';
import { getProcessedData } from '../services/mailchimp';

const ProvincePage = () => {
  console.log('ProvincePage mounted');
  const { provincie } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [stats, setStats] = useState(null);
  const [processedData, setProcessedData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const processedData = await getProcessedData();
      setProcessedData(processedData);
      
      const provincieKey = provincie.toLowerCase();
      if (!processedData[provincieKey]) {
        navigate('/');
        return;
      }

      const provincieData = processedData[provincieKey];
      const totalSchools = Object.values(provincieData.gemeentes).reduce(
        (sum, gemeente) => sum + Object.keys(gemeente.schools).length,
        0
      );

      setStats({
        children: provincieData.count,
        schools: totalSchools
      });
      setData(provincieData.gemeentes);
    };

    fetchData();
  }, [provincie, navigate]);

  if (!data || !processedData) return <div className="loading">Loading...</div>;

  return (
    <Layout 
      region={processedData[provincie.toLowerCase()]?.displayName || provincie}
      stats={stats}
    >
      <div className="prompt">
        <p>Selecteer je gemeente om meer data te per school te zien</p>
      </div>
      <div className="break"></div>
      <ResultsList 
        items={data} 
        baseUrl={`/${provincie.toLowerCase()}`}
      />
    </Layout>
  );
};

export default ProvincePage;